export enum RangeTypeEnum {
    sell = 'sell',
    buy = 'buy',
    buyback = 'buyback',
    sellback = 'sellback',
    priceRetention = 'priceRetention',
    tradeVolume = 'tradeVolume',
    cexTradeVolume = 'cexTradeVolume',
    liquidity = 'liquidity',
    holder = 'holder',
    maker = 'maker',
    transferBundler = 'transferBundler',
    cexTrendMode = 'cexTrend',
    priceFollowing = 'priceFollowing',
    fairLaunch = 'fairLaunch',
    cexListing = 'cexListing',
    cexOB = 'cexOB',
}

export enum StrategiesType {
    Counter = 'counter',
    Target = 'target',
}

export enum BaseStrategiesCurrencyEnum {
    usd = 'usd',
    base = 'base',
    quote = 'quote',
}

export enum TxAmountCurrencyEnum  {
    usd = 'usd',
    base = 'base',
    quote = 'quote',
}

export enum PriceCurrencyEnum {
    usd = 'usd',
    quote = 'quote',
}

export enum RangeParamEnum {
    midPrice = 'midPrice',
}

export enum RangeStatusEnum {
    archived = 'archived',
    active = 'active',
    deleted = 'deleted',
    finished = 'finished',
    paused = 'paused',
}

export enum RangeLimitCurrencyEnum {
    usd = 'usd',
    base = 'base',
    quote = 'quote',
}

export enum StrategySwapType {
    sell = 'sell',
    buy = 'buy',
    rebalance = 'rebalance'
}

export enum TradeTimeframeEnum {
    MINUTES_1 = '1m',
    MINUTES_5 = '5m',
    MINUTES_15 = '15m',
    HOURS_1 = '1h',
    HOURS_4 = '4h',
    DAYS_1 = '1d',
    WEAK_1 = '1w',
    MONTH_1 = '1M',
}
